// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';
import {findMatchingKey} from '../../../claim/shared/services/claim-shared-helper';
import {readDebit} from './get-debit';
import {routerActions} from 'react-router-redux';

export const updateFullDebitComments = comments => ({
    comments,
    type: actions.UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_ITEM_COMMENTS
});

export const updateFullDebitModalVisibility = visibility =>

    dispatch => {

        addRemoveModalClass(visibility);

        dispatch({
            type: actions.UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_MODAL_VISIBILITY,
            visibility
        });

    };

export const updateClaimNumber = claimNumber => ({
    claimNumber,
    type: actions.UPDATE_TCSM_CLAIM_DEBIT_CLAIM_NUMBER
});

export const updateDebitType = (key, list) => ({
    debitType: findMatchingKey(key, list),
    type: actions.UPDATE_TCSM_CLAIM_DEBIT_TYPE
});

export const handleDebit = (claimNumber, debitType, debitTypes) =>

    dispatch => {

        if (debitType === 'F') {

            readDebit(claimNumber, debitType, debitTypes)(dispatch);

        } else if (debitType === 'P') {

            dispatch(routerActions.push(`/tcsm/audits/record/partial-debit?claimNumber=${claimNumber}`));

        } else {

            dispatch(routerActions.push(`/tcsm/audits/record/percentage-debit?claimNumber=${claimNumber}`));

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/action-creators/claim-debit.js